module.exports = __webpack_public_path__ + "media/styles/images/svg/plus-teal-eda492da190d44114cf26c509c94ed86.svg";